/**
 * Workspace seats — included seats, paid add-on rate, and rollout flag.
 * Keep in sync with Stripe Price IDs used in Cloud Functions billing.
 */

/** When false: seats UI/backend callables hidden; Phase 2 can ship incrementally */
export const WORKSPACE_SEATS_ENABLED = true;

/** Owner counts as one included editor seat on all plans */
export const INCLUDED_SEATS_FREE = 1;

/** Unified capture-pack era: 1 included seat; extra seats via Stripe seat add-on */
export const INCLUDED_SEATS_CAPTURE_PACK = 1;

/** Monthly USD per extra seat (Volugraph Seat Addon — Stripe recurring price) */
export const EXTRA_SEAT_PRICE_USD = 25;

/** @deprecated Legacy Professional tier — use EXTRA_SEAT_PRICE_USD */
export const EXTRA_SEAT_PRICE_USD_PROFESSIONAL = EXTRA_SEAT_PRICE_USD;

/** @deprecated Legacy Studio tier — use EXTRA_SEAT_PRICE_USD */
export const EXTRA_SEAT_PRICE_USD_STUDIO = EXTRA_SEAT_PRICE_USD;

/** @deprecated Legacy Professional tier — use INCLUDED_SEATS_CAPTURE_PACK */
export const INCLUDED_SEATS_PROFESSIONAL = INCLUDED_SEATS_CAPTURE_PACK;

/** @deprecated Legacy Studio tier — use INCLUDED_SEATS_CAPTURE_PACK + add-ons */
export const INCLUDED_SEATS_STUDIO = INCLUDED_SEATS_CAPTURE_PACK;

/** Pricing card / checklist copy for seat add-on line */
export function formatSeatAddonFeatureLine() {
  return `${INCLUDED_SEATS_CAPTURE_PACK} seat included (extra seats $${EXTRA_SEAT_PRICE_USD}/month each)`;
}
